import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    let title: string;

    switch (true) {
      default:
        title = 'Alacaza Pro';
        break;
    }

    document.title = title;
  }, [location]);
};

export default usePageTitle;
